import { sanitizeCustomHtml } from "@redotech/order-tracking-common/sanitize-custom-html";
import { RichTextElement } from "@redotech/redo-content-builder-common/element-schema";
import { quillStyles } from "@redotech/redo-content-builder-common/quill-styles";
import htmlReactParser from "html-react-parser";
import { memo } from "react";
import { getBaseElementStyles } from "./base-element-styles";
import { ElementBox } from "./element-box";
import { getRichTextContainerStyles } from "./rich-text-shared-styles";

export const RichText = memo(function RichText({
  element,
}: {
  element: Omit<RichTextElement, "id" | "type"> & {
    id: string | number;
    type: string;
  };
}) {
  const containerId = `container-${element.id}`;
  const baseStyles = getBaseElementStyles(element);

  return (
    <>
      <style>
        {/* TODO - Find a way to include all the quill styles automatically */}
        {getRichTextContainerStyles(containerId, element.linkColor)}
        {quillStyles}
      </style>
      <ElementBox
        alignment={element.contentAlignment}
        fillsWidth
        id={containerId}
        // design-allow: merchant-authored text styles have no tokens
        style={{
          ...baseStyles,
          color: element.textColor,
          fontSize: element.fontSizePx,
          fontFamily: `'${element.fontFamily}'`,
          lineHeight: 1.42, // match Quill Editors
        }}
      >
        <div>
          {/* Merchant-authored (or URL-forced) HTML renders in the builder on
            app.getredo.com and on the storefront, so sanitize at the sink. */}
          {htmlReactParser(sanitizeCustomHtml(element.html))}
        </div>
      </ElementBox>
    </>
  );
});
